import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native';
import Collapsible from 'react-native-collapsible';
import MyCheckbox from '../MyCheckbox';
import MyText from '../MyText';
import MyTextInput from '../MyTextInput';
import AnnexForm from './AnnexForm';
import { AntDesign } from '@expo/vector-icons'; 

const Annex = (props) => {
    const [collapsed, setCollapsed] = React.useState(true);

    const [oilyBilgeWater, setOilyBilgeWater] = React.useState(false);
    const [oilyResidues, setOilyResidues] = React.useState(false);
    const [oilyTank, setOilyTank] = React.useState(false);
    const [dirtyBallast, setDirtyBallast] = React.useState(false);
    const [scale, setScale] = React.useState(false);
    const [other, setOther] = React.useState(false);

    const [oilyBilgeWaterData, setOilyBilgeWaterData] = React.useState({});
    const [oilyResiduesData, setOilyResiduesData] = React.useState({});
    const [oilyTankData, setOilyTankData] = React.useState({});
    const [dirtyBallastData, setDirtyBallastData] = React.useState({});
    const [scaleData, setScaleData] = React.useState({});
    const [otherData, setOtherData] = React.useState({});

    React.useEffect(() => {
        onChange();
    }, [oilyBilgeWater, oilyResidues, oilyTank, dirtyBallast, scale, other,
        oilyBilgeWaterData, oilyResiduesData, oilyTankData, dirtyBallastData, scaleData, otherData]);

    const onChange = () => {
        props.onChange({
            oilyBilgeWater: {
                active: oilyBilgeWater,
                data: oilyBilgeWaterData
            },
            oilyResidues: {
                active: oilyResidues,
                data: oilyResiduesData
            },
            oilyTank: {
                active: oilyTank,
                data: oilyTankData
            },
            dirtyBallast: {
                active: dirtyBallast,
                data: dirtyBallastData
            },
            scale: {
                active: scale,
                data: scaleData
            },
            other: {
                active: other,
                data: otherData
            },
        });
    }

    return (
        <View style={styles.annexContainer}>
            <MyText style={styles.annexTitle} onPress={() => {setCollapsed(prev => !prev)}}>{props.title}</MyText>
            <View style={{position: 'absolute', right: 10, top: 14}}>
                <AntDesign name="down" size={12} color="#461b6f" style={{transform: [{rotate: collapsed?'0deg':'180deg'}]}}/>
            </View>
            <View style={styles.formContainer}>
                <View style={{display: collapsed?'none':'flex'}}>
                    <View style={styles.row}>
                        <MyCheckbox onClick={() => {setOilyBilgeWater(prev => !prev);}} checked={oilyBilgeWater} label='Oily Bilge Water'/>
                    </View>
                    {
                        oilyBilgeWater && 
                        <View style={[styles.row]}>
                            <AnnexForm onChange={setOilyBilgeWaterData}/>
                        </View>
                    }
                    <View style={styles.row}>
                        <MyCheckbox onClick={() => {setOilyResidues(prev => !prev);}} checked={oilyResidues} label='Oily Residues - Sludge'/>
                    </View>
                    {
                        oilyResidues &&
                        <View style={[styles.row]}>
                            <AnnexForm onChange={setOilyResiduesData}/>
                        </View>
                    }
                    <View style={styles.row}>
                        <MyCheckbox onClick={() => {setOilyTank(prev => !prev);}} checked={oilyTank} label='Oily tank water - Slops'/>
                    </View>
                    {
                        oilyTank &&
                        <View style={[styles.row]}>
                            <AnnexForm onChange={setOilyTankData}/>
                        </View>
                    }
                    <View style={styles.row}>
                        <MyCheckbox onClick={() => {setDirtyBallast(prev => !prev);}} checked={dirtyBallast} label='Dirty ballast water'/>
                    </View>
                    {
                        dirtyBallast &&
                        <View style={[styles.row]}>
                            <AnnexForm onChange={setDirtyBallastData}/>
                        </View>
                    }
                    <View style={styles.row}>
                        <MyCheckbox onClick={() => {setScale(prev => !prev);}} checked={scale} label='Scale and sludge from tank cleaning'/>
                    </View>
                    {
                        scale &&
                        <View style={[styles.row]}>
                            <AnnexForm onChange={setScaleData}/>
                        </View>
                    }
                    <View style={styles.row}>
                        <MyCheckbox onClick={() => {setOther(prev => !prev);}} checked={other} label='Other (please specify)'/>
                    </View>
                    {
                        other &&
                        <View style={[styles.row]}>
                            <AnnexForm onChange={setOtherData}/>
                        </View>
                    }
                </View>
            </View>
        </View>
    )
}
const styles = StyleSheet.create({
    annexContainer: {
        marginBottom: 0
    },
    annexTitle: {
        backgroundColor: '#e9e3f0',
        color: '#57307e',
        textAlign: 'center',
        width: '100%',
        padding: 10
    },
    formContainer: {
        padding: 20,
        paddingTop: 15,
        paddingVertical: 0,
        flex: 1
    },
    row: {
        marginBottom: 15
    }
})
export default Annex